import { render, staticRenderFns } from "./WUploadReceipt.vue?vue&type=template&id=30a3eebc&scoped=true&"
import script from "./WUploadReceipt.vue?vue&type=script&lang=js&"
export * from "./WUploadReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a3eebc",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WPrice from '@/components/WPrice.vue'
import WUpload from '@/components/WUpload.vue'
autoInstallComponents(component, {WPrice,WUpload})
